import React from 'react';
import PropTypes from 'prop-types';
import Filter, { FilterModal, FilterSection } from './Filter';
import UtrFilterComponent from './FilterComponents/UtrFilterComponent';

import styles from '../search.scss';
import { ratingTypes } from '../../../utils/constants';

const UtrFilter = (props) => {
    const { isMemberFilter, isClubFilter, type = '', filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, handleFilterUpdate, isHalfSteps, isLeaguesTab, showExpandedUtrFilter, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;
    const { sportTypes } = filters;
    let tennis;
    let pickleball;
    if (sportTypes) {
        ({ tennis, pickleball } = sportTypes);
    }

    const isActive = (filters && (filters.utrMin > 1 || (tennis && filters.utrMax < 16) || (pickleball && filters.utrMax < 10) || !!filters.utrType || !!filters.utrTeamType || !!filters.utrReliability)) || filterModal === 'utr';
    const isLeaguesActive = isLeaguesTab ? (filters.utrMin > 1 || filters.utrMax < 16) : isActive;

    const value = (filters && (filters.utrMin >= 1 && filters.utrMax <= 16)) ? `${filters.utrMin.toFixed(1)} - ${filters.utrMax.toFixed(1)}` : 'All ratings';
    const bothSportTypesSelected = tennis && pickleball;
    const noSportTypesSelected = !tennis && !pickleball;

    const getValue = () => {
        if (isMemberFilter) {
            return 'UTR';
        } if (type === 'collegeCorner') {
            return value;
        }
        return 'Rating';
    };
    const finalValue = getValue();
    return (
        <div className={`${styles.filterWrapper} `}>

            <Filter
                filterName={'utr'}
                handleFilterClick={handleFilterClick}
                isActive={isLeaguesActive}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                searchFor={type}
                filterInputs={filterInputs}
                bothSportTypesSelected={bothSportTypesSelected}
                noSportTypesSelected={noSportTypesSelected}
                utrFilter={true}
                isPickleballFilter={pickleball}
                isMemberFilter={isMemberFilter}
                data-testid={dataTestId}
            >
                {finalValue}
            </Filter>
            {filterModal === 'utr' && (
                <FilterModal
                    title={`${ratingTypes.tennis} Range`}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    isPickleballFilter={pickleball}
                    data-testid={dataTestId}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>
                        <UtrFilterComponent
                            filterInputs={filterInputs}
                            isHalfSteps={isHalfSteps}
                            handleUTRChange={(range) => {
                                handleFilterUpdate({
                                    utrMin: range[0],
                                    utrMax: range[1],
                                });
                            }}
                            showExpandedUtrFilter={showExpandedUtrFilter}
                            handleUtrTypeClick={(utrType) => {
                                handleFilterUpdate({ utrType });
                            }}
                            handleUtrTeamTypeClick={(utrTeamType) => {
                                handleFilterUpdate({ utrTeamType });
                            }}
                            handleUtrReliabilityClick={(utrReliability) => {
                                handleFilterUpdate({ utrReliability });
                            }}
                            filters={filters}
                            isMemberFilter={isMemberFilter}
                            isClubFilter={isClubFilter}
                            data-testid={dataTestId && `${dataTestId}.utr-filter`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

UtrFilter.propTypes = {
    filters: PropTypes.instanceOf(Object),
    isMemberFilter: PropTypes.bool,
    isClubFilter: PropTypes.bool,
    'data-testid': PropTypes.string,
};

UtrFilter.defaultProps = {
    filters: null,
    isMemberFilter: false,
    isClubFilter: false,
    'data-testid': undefined,
};
export default UtrFilter;
